<template>
  <lay-row space="10">
    <lay-col md="24">
      <lay-panel>
        <lay-form :model="search" style="text-align: start" size="sm">
          <lay-form-item label="账号" prop="key" mode="inline">
            <lay-input v-model="search.key" placeholder="请输入账号"></lay-input>
          </lay-form-item> 

          <lay-form-item label="状态" prop="state" mode="inline">
            <lay-select v-model="search.state">
              <lay-select-option value="0" label="全部"></lay-select-option>
              <lay-select-option value="1" label="正常"></lay-select-option>
              <lay-select-option value="2" label="禁用"></lay-select-option>

            </lay-select>
          </lay-form-item>

          <lay-form-item mode="inline">
            <lay-button type="primary" size="sm" @click="searchUser">查询</lay-button>
          </lay-form-item>

        </lay-form>
        <lay-table :page="page" :height="'100%'" :columns="columns" :loading="loading" :data-source="dataSource"
          v-model:selected-keys="selectedKeys" @change="change" @sortChange="sortChange">
          <template #state="{ row }">
            <lay-switch :model-value="row.state == 0 ? true : false" @change="changedelFlag(row)" onswitch-text="正常"
              unswitch-text="禁用"></lay-switch>
          </template>


          <template #guarantee="{ row }">
            <lay-switch :model-value="row.guarantee == 2 ? true : false" @change="changeGuarantee(row)" onswitch-text="担保"
              unswitch-text="不担保"></lay-switch>
          </template>


          

          
          <template v-slot:operator="{ row }">
            <lay-button size="xs" type="primary" @click="updateUser(row)">编辑</lay-button>
            <lay-button size="xs" type="primary" @click="updatefeng(row)">批量楼凤修改</lay-button>
          </template>
        </lay-table>



      </lay-panel>
    </lay-col>

  </lay-row>


  <lay-layer v-model="visible11" :shade="false" :area="['350px', '550px']" :btn="action11" title="修改用户信息">
    <div style="padding: 20px;">
      <lay-form :model="user" ref="layFormRef11" :pane="true">
        <lay-form-item label="账户" prop="userName" required>
          <lay-input v-model="user.userName" :disabled="isDisabled"></lay-input>
        </lay-form-item>
        <lay-form-item label="密码" prop="password">
          <lay-input v-model="user.password" type="text" placeholder="无需修改请置空"></lay-input>
        </lay-form-item>  
        <lay-form-item label="到期时间" prop="endTime"  required>
          <lay-date-picker type="datetime" v-model="user.endTime" placeholder="请选择会员到期时间"></lay-date-picker>
        </lay-form-item>

        <lay-form-item label="备注" prop="notes" required>

          <lay-textarea placeholder="请输入备注" v-model="user.notes">
          </lay-textarea>

        </lay-form-item>



      </lay-form>
    </div>
  </lay-layer>



  <lay-layer v-model="isfeng" :shade="false" :area="['350px', '400px']" :btn="fengbtu" title="批量修改楼凤信息">
    <div style="padding: 20px;">
      <lay-form :model="fengLouInfo"  :pane="true">
        <lay-form-item label="手机号" prop="phone" required>
          <lay-input v-model="fengLouInfo.phone"></lay-input>
        </lay-form-item>
        <lay-form-item label="qq" prop="qq" required>
          <lay-input v-model="fengLouInfo.qq"></lay-input>
        </lay-form-item>
        <lay-form-item label="微信" prop="weChat" required>
          <lay-input v-model="fengLouInfo.weChat"></lay-input>
        </lay-form-item>

        <lay-form-item label="飞机" prop="plain" required>
          <lay-input v-model="fengLouInfo.plain"></lay-input>
        </lay-form-item> 

      </lay-form>
    </div>
  </lay-layer>


</template>

<script lang="ts" setup>
import { ref, reactive } from 'vue'
import { layer } from '@layui/layer-vue'

import { allUser, disableUsers, modifyUserInfo ,contactInfoFengLou,guaranteeUsers} from '../../api'




const search = reactive({
  key: "",
  state: "0", 
})


const loading = ref(false);

const selectedKeys = ref([]);

const dataSource = ref([]);

const page = reactive({ current: 1, limit: 10, total: 0 });

const columns = ref([
  { title: "用户ID", width: "260px", key: "userId", align: "center" },
  { title: "账号", key: "userName", align: "center" },
  { title: "邮箱", key: "email", align: "center" },
  { title: "状态", key: "state", align: "center", customSlot: "state" },
  { title: "担保", key: "guarantee", align: "center", customSlot: "guarantee" }, 
  { title: "积分", key: "member", align: "center", customSlot: "member" },
  { title: "到期时间", key: "endTime", align: "center" },
  { title: "备注", key: "notes", align: "center" },
  { title: "注册时间", key: "addTime", align: "center" },
  { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center", width: "200px" }
]);


const getAllUser = () => {
  loading.value = true;
  var data = { "page": page.current, "limit": page.limit, "key": search.key, "state": search.state, "type": search.type };
  allUser(JSON.stringify(data)).then((res: any) => {
    loading.value = false;
    if (res != "" && res.code == 0) {
      dataSource.value = res.data;
      page.total = res.count;
    } else {
      dataSource.value = [];
      page.total = 0;
    }
  })
}

getAllUser();

const change = (page: any) => {
  getAllUser();
}

const sortChange = (key: any, sort: any) => {
  layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
}


//禁用或者开启
const changedelFlag = (row: any) => {

  var data = { "key": row.userId, "id": row.delFlag };
  disableUsers(JSON.stringify(data)).then((res: any) => {
    if (res != "" && res.code == 0) {
      getAllUser();
      layer.msg("操作成功", { time: 1000, icon: 1 });
    }
  })
}


const changeGuarantee = (row: any) => { 
  var data = { "key": row.userId, "id": row.guarantee };
  guaranteeUsers(JSON.stringify(data)).then((res: any) => {
    if (res != "" && res.code == 0) {
      getAllUser();
      layer.msg("操作成功", { time: 1000, icon: 1 });
    }
  })
}






//搜索
const searchUser=()=>{
  page.current=1;

  getAllUser();
}




const user = reactive({
  userId: "",
  userName: "",
  password: "", 
  endTime: "",
  notes: ""
})


const fengLouInfo = reactive({
  userId: "",
  phone: "",
  qq: "", 
  weChat: "",
  plain: ""
})






const  updateUser = (row: any) => {
  user.userId = row.userId;
  user.userName = row.userName; 
  user.endTime = row.endTime;
  user.notes = row.notes==null?"":row.notes;
  user.password = "";
  isDisabled.value = true;
  visible11.value = !visible11.value;
}


const updatefeng = (row: any) => {
  fengLouInfo.userId = row.userId; 
  isfeng.value = !isfeng.value;
}





const layFormRef11 = ref();

const visible11 = ref(false);
const isfeng = ref(false);



const isDisabled = ref(false);

const action11 = ref([
  {
    text: "确认",
    callback: () => {
 

      modifyUserInfo(JSON.stringify(user)).then((res: any) => {
        if (res != "" && res.code == 0) {
          getAllUser();
          visible11.value = false;
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })
    }
  },
  {
    text: "取消",
    callback: () => {
      visible11.value = false;
    }
  }
])



const fengbtu = ref([
  {
    text: "确认",
    callback: () => {
 

      contactInfoFengLou(JSON.stringify(fengLouInfo)).then((res: any) => {
        if (res != "" && res.code == 0) {
      
          isfeng.value = false;
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })
    }
  },
  {
    text: "取消",
    callback: () => {
      isfeng.value = false;
    }
  }
])




</script>

<style scoped></style>